import { PetsApi } from './generated-src';
import { getAppSetting } from '../config/AppSettings';

export default function() {
  const apiBasePath = `${getAppSetting('apiUrl')}/jwt`;
  return new PetsApi(undefined, apiBasePath);
}
